import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) {
                el.style.backgroundImage = `url('/${bg}')`;
            }
        });
    }, []);

    return (
        <>
            {/* <!-- Contact Widget Begin --> */}
            <div className="contact-widget set-bg" data-setbg="img/contact-widget.jpg">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 col-md-7">
                            <div className="row">
                                <div className="col-lg-5 col-md-6">
                                    <div className="contact__widget__item">
                                        <h4>Surat Office</h4>
                                        <p>203A Sovereign Shopper NR, Sindhu Seva Samiti School, Adajan, Surat - 395009</p>
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6">
                                    <div className="contact__widget__item">
                                        <h4>Silvassa Office</h4>
                                        <p>1st Floor, Shop No 5, Jalaram Complex, Opp Jama Masjid, ITI Road, Silvassa - 396230</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-5">
                            <div className="contact__widget__phone">
                                <span>Call Us Now — We're Happy To Help!</span>
                                <h2>+91 6354894678</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Contact Widget End --> */}

            {/* <!-- Footer Section Begin --> */}
            <footer className="footer">
                <div className="container">
                    <div className="row">

                        {/* Col 1 — About */}
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer__about">
                                <p>We are a trusted financial services provider offering Personal Loans, Business Loans, Home Loans, Gold Loans, Insurance, and more — with fast approvals and complete transparency.</p>
                                <ul className="footer__widget--social">
                                    <li><a href="#"><i className="fa fa-facebook"></i></a></li>
                                    <li><a href="https://www.instagram.com/vijayprimes/" target="_blank" rel="noreferrer"><i className="fa fa-instagram"></i></a></li>
                                    <li><a href="#"><i className="fa fa-twitter"></i></a></li>
                                    <li><a href="#"><i className="fa fa-whatsapp"></i></a></li>
                                </ul>
                            </div>
                        </div>

                        {/* Col 2 — Services */}
                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div className="footer__widget">
                                <h5>Our Services</h5>
                                <ul>
                                    <li><Link to="/services">Personal Loan</Link></li>
                                    <li><Link to="/services">Business Loan</Link></li>
                                    <li><Link to="/services">Loan Against Property</Link></li>
                                    <li><Link to="/services">Credit Card</Link></li>
                                    <li><Link to="/services">Balance Transfer &amp; Top-Up</Link></li>
                                    <li><Link to="/services">Gold Loan</Link></li>
                                    <li><Link to="/services">Car Loan</Link></li>
                                    <li><Link to="/services">Home Loan</Link></li>
                                    <li><Link to="/services">Insurance</Link></li>
                                </ul>
                            </div>
                        </div>

                        {/* Col 3 — Quick Links */}
                        <div className="col-lg-2 col-md-6 col-sm-6">
                            <div className="footer__widget">
                                <h5>Quick Links</h5>
                                <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about">About Us</Link></li>
                                    <li><Link to="/services">Services</Link></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>

                        {/* Col 4 — Working Hours + Contact Info */}
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="footer__widget footer__widget--address">
                                <h5>Working Hours</h5>
                                <ul>
                                    <li>Mon – Fri: &nbsp; 11:00 am – 8:00 pm</li>
                                    <li>Saturday: &nbsp; 10:00 am – 6:00 pm</li>
                                    <li>Sunday: &nbsp;&nbsp; 11:00 am – 6:00 pm</li>
                                </ul>
                                <h5 style={{ marginTop: '20px' }}>Contact Info</h5>
                                <ul>
                                    <li>
                                        <i className="fa fa-phone" style={{ marginRight: '8px' }}></i>
                                        <a href="tel:+918401064678">+91 6354894678</a>
                                    </li>
                                    <li>
                                        <i className="fa fa-envelope" style={{ marginRight: '8px' }}></i>
                                        <a href="mailto:support@vijayprimes.com">support@vijayprimes.com</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    {/* Copyright Row */}
                    <div className="footer__copyright">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <ul className="footer__copyright__links">
                                    <li><a href="#">Terms of Use</a></li>
                                    <li><a href="#">Privacy Policy</a></li>
                                    <li><Link to="/contact">Contact Us</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-6 col-md-6 text-right">
                                <div className="footer__copyright__text">
                                    <p>Copyright &copy; {new Date().getFullYear()} All rights reserved by <Link to="/">Vijay Primes</Link></p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </footer>
            {/* <!-- Footer Section End --> */}

            {/* <!-- Search Begin --> */}
            <div className="search-model">
                <div className="h-100 d-flex align-items-center justify-content-center">
                    <div className="search-close-switch">+</div>
                    <form className="search-model-form">
                        <input type="text" id="search-input" placeholder="Search here....." />
                    </form>
                </div>
            </div>
            {/* <!-- Search End --> */}
        </>
    );
}

export default Footer;